{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-320000",
  "sheetId": "StatementOfProfitOrLossByNature",
  "label": "[320000] Statement of profit or loss using classification by nature of expense method (MPERS)",
  "description": "Statement of profit or loss using classification by nature of expense method",
  "controls": [
    {
      "qname": "ssmt-mpers:StatementOfProfitOrLossByNatureHeader",
      "label": "STATEMENT OF PROFIT OR LOSS (BY NATURE)",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 1
      }
    },
    {
      "qname": "ssmt-mpers:RevenueAndIncomeHeader",
      "label": "REVENUE AND INCOME",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ifrs-smes:RevenueByNature",
      "label": "Revenue",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:OtherIncomeByNature",
      "label": "Other income",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ExpensesByNatureHeader",
      "label": "EXPENSES BY NATURE",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ifrs-smes:ChangesInInventoriesOfFinishedGoodsAndWorkInProgressByNature",
      "label": "Changes in inventories of finished goods and work in progress",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:RawMaterialsAndConsumablesUsedByNature",
      "label": "Raw materials and consumables used",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-smes:EmployeeBenefitsExpenseByNature",
      "label": "Employee benefits expense",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-smes:DepreciationAndAmortisationExpenseByNature",
      "label": "Depreciation and amortisation expense",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-smes:ImpairmentLossRecognisedInProfitOrLoss",
      "label": "Impairment loss recognised in profit or loss",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-smes:TransportationExpense",
      "label": "Transportation expense",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-smes:AdvertisingAndMarketingExpense",
      "label": "Advertising and marketing expense",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-smes:RentalExpenseByNature",
      "label": "Rental expense",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-smes:UtilitiesExpenseByNature",
      "label": "Utilities expense",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-smes:ProfessionalFeesExpense",
      "label": "Professional fees expense",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-smes:InsuranceExpenseByNature",
      "label": "Insurance expense",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-smes:ForeignExchangeLossByNature",
      "label": "Foreign exchange loss",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-smes:OtherExpensesByNature",
      "label": "Other expenses",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-smes:ProfitFromOperationsByNature",
      "label": "PROFIT FROM OPERATIONS",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true,
        "calculation": "Revenue + OtherIncome - All Expenses"
      }
    },
    {
      "qname": "ssmt-mpers:FinanceItemsHeader",
      "label": "FINANCE AND ASSOCIATES/JOINT VENTURES",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ifrs-smes:FinanceCostsByNature",
      "label": "Finance costs",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-smes:FinanceIncomeByNature",
      "label": "Finance income",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ShareOfProfitOfAssociatesByNature",
      "label": "Share of profit of associates",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ShareOfProfitOfJointVenturesByNature",
      "label": "Share of profit of joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ProfitBeforeTaxByNature",
      "label": "PROFIT BEFORE TAX",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true,
        "calculation": "ProfitFromOperations + FinanceIncome - FinanceCosts + ShareOfAssociates + ShareOfJVs"
      }
    },
    {
      "qname": "ssmt-mpers:TaxationByNatureHeader",
      "label": "TAXATION",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ifrs-smes:IncomeTaxExpenseByNature",
      "label": "Income tax expense",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-smes:ProfitForTheYearByNature",
      "label": "PROFIT FOR THE YEAR",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true,
        "calculation": "ProfitBeforeTax - IncomeTaxExpense"
      }
    },
    {
      "qname": "ssmt-mpers:AttributionByNatureHeader",
      "label": "PROFIT ATTRIBUTABLE TO:",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ifrs-smes:ProfitAttributableToOwnersOfParentByNature",
      "label": "Owners of the parent",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ProfitAttributableToNonControllingInterestsByNature",
      "label": "Non-controlling interests",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:TotalProfitAttributionByNature",
      "label": "Total",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true,
        "calculation": "ProfitAttributableToOwnersOfParent + ProfitAttributableToNonControllingInterests"
      }
    },
    {
      "qname": "ssmt-mpers:EarningsPerShareByNatureHeader",
      "label": "EARNINGS PER SHARE",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ifrs-smes:BasicEarningsPerShareByNature",
      "label": "Basic earnings per share (sen)",
      "type": "PerShareItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "decimalPlaces": 2
      }
    },
    {
      "qname": "ifrs-smes:DilutedEarningsPerShareByNature",
      "label": "Diluted earnings per share (sen)",
      "type": "PerShareItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "decimalPlaces": 2
      }
    }
  ],
  "roleId": "role-320000-mpers",
  "roleUri": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mpers_2022-12-31/ssmt-fs-mpers_2022-12-31_role-320000",
  "taxonomy": "FS-MPERS"
}